var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPhoneAccepted = function SvgPhoneAccepted(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68917 7.64292C5.70917 9.6475 7.3525 11.2837 9.35708 12.3108L10.9154 10.7525C11.1067 10.5612 11.39 10.4975 11.6379 10.5825C12.4312 10.8446 13.2883 10.9862 14.1667 10.9862C14.5562 10.9862 14.875 11.305 14.875 11.6946V14.1667C14.875 14.5562 14.5562 14.875 14.1667 14.875C7.51542 14.875 2.125 9.48458 2.125 2.83333C2.125 2.44375 2.44375 2.125 2.83333 2.125H5.3125C5.70208 2.125 6.02083 2.44375 6.02083 2.83333C6.02083 3.71875 6.1625 4.56875 6.42458 5.36208C6.5025 5.61 6.44583 5.88625 6.2475 6.08458L4.68917 7.64292Z",
    fill: "#5D9C62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36859 14.5201L4.7223 14.8741L5.07602 14.5201L11.6871 7.90293L12.039 7.55079L11.6884 7.1974L10.5232 6.02286L10.1695 5.66632L9.81449 6.02161L4.72162 11.1191L2.93499 9.33776L2.58127 8.98509L2.22824 9.33844L1.06303 10.5047L0.709963 10.8581L1.06303 11.2115L4.36859 14.5201Z",
    fill: "#5D9C62",
    stroke: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneAccepted, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phone-accepted.6e78bd81.svg";
export { ForwardRef as ReactComponent };